(function() {
  var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  function getSizeGroups(card) {
    return card.querySelectorAll('.quick-add .buttons .qa-size-group');
  }

  function showSizeGroup(card, colorKey) {
    if (!colorKey) return;
    var groups = getSizeGroups(card);
    if (!groups.length) return;

    var matched = null;
    groups.forEach(function(group) {
      if (group.getAttribute('data-qa-color-key') === colorKey) {
        matched = group;
      }
    });

    if (!matched) return;

    groups.forEach(function(group) {
      group.hidden = (group !== matched);
    });
  }

  function restoreSizeGroup(card) {
    var groups = getSizeGroups(card);
    if (!groups.length) return;

    var defaultGroup = card.querySelector('.quick-add .buttons .qa-size-group[data-default]') || groups[0];
    groups.forEach(function(group) {
      group.hidden = (group !== defaultGroup);
    });
  }

  function initSwatchSwap() {
    var cards = document.querySelectorAll('.product-card');

    cards.forEach(function(card) {
      if (card.dataset.swatchCardInit) return;

      var swatchItems = card.querySelectorAll('.swatch-hover-wrap[data-qa-color-key]');
      var hasSizeGroups = getSizeGroups(card).length > 0;

      var imgItems = card.querySelectorAll('.swatch-hover-wrap[data-variant-img-large]');
      var mainImg = card.querySelector('.product-card__media a > img');
      var canSwapImage = imgItems.length >= 2 && !!mainImg;

      // Nothing to wire up on this card.
      if (!swatchItems.length && !canSwapImage) return;
      card.dataset.swatchCardInit = 'true';

      var originalSrc = mainImg ? mainImg.src : '';
      var originalSrcset = mainImg ? (mainImg.srcset || '') : '';
      var preloaded = {};

      if (canSwapImage) {
        imgItems.forEach(function(li) {
          var imgUrl = li.getAttribute('data-variant-img-large');
          if (imgUrl && !preloaded[imgUrl]) {
            var img = new Image();
            img.src = imgUrl;
            preloaded[imgUrl] = img;
          }
        });
      }

      function swapImage(imgUrl) {
        if (!mainImg) return;
        mainImg.src = imgUrl;
        mainImg.srcset = '';

        var secondaryDiv = card.querySelector('.product-card__secondary');
        if (secondaryDiv) {
          secondaryDiv.style.visibility = 'hidden';
        }
      }

      function restoreImage() {
        if (!mainImg) return;
        mainImg.src = originalSrc;
        mainImg.srcset = originalSrcset;

        var secondaryDiv = card.querySelector('.product-card__secondary');
        if (secondaryDiv) {
          secondaryDiv.style.visibility = '';
        }
      }

      function setActiveState(activeLi) {
        swatchItems.forEach(function(item) {
          item.classList.remove('swatch-active');
        });
        if (activeLi) {
          activeLi.classList.add('swatch-active');
        }
      }

      // Bind every colour swatch. The size-group toggle works even when a colour
      // has no image, so it must not depend on the image-swap path.
      var bindItems = swatchItems.length ? swatchItems : imgItems;

      bindItems.forEach(function(li) {
        var swatchLink = li.querySelector('a.color-swatch');
        if (!swatchLink) return;

        var colorKey = li.getAttribute('data-qa-color-key');
        var imgLarge = li.getAttribute('data-variant-img-large');

        if (isTouchDevice) {
          swatchLink.addEventListener('click', function(e) {
            // Only hijack the tap when we have an in-card preview to show; otherwise
            // let the link navigate so click-through is preserved.
            if (canSwapImage && imgLarge) {
              e.preventDefault();
              e.stopPropagation();

              swapImage(imgLarge);
              setActiveState(li);

              var variantUrl = li.getAttribute('data-variant-url');
              if (variantUrl) {
                var titleLink = card.querySelector('.product-card__title');
                if (titleLink) titleLink.setAttribute('href', variantUrl);

                var mediaLink = card.querySelector('.product-card__media > a');
                if (mediaLink) mediaLink.setAttribute('href', variantUrl);
              }
            }

            if (hasSizeGroups && colorKey) {
              showSizeGroup(card, colorKey);
            }
          });
        } else {
          swatchLink.addEventListener('mouseenter', function() {
            if (canSwapImage && imgLarge) {
              swapImage(imgLarge);
              setActiveState(li);
            }
            if (hasSizeGroups && colorKey) {
              showSizeGroup(card, colorKey);
            }
          });

          swatchLink.addEventListener('mouseleave', function() {
            if (canSwapImage) {
              restoreImage();
              setActiveState(null);
            }
            if (hasSizeGroups) {
              restoreSizeGroup(card);
            }
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchSwap);
  } else {
    initSwatchSwap();
  }

  var observer = new MutationObserver(function(mutations) {
    var hasNewCards = mutations.some(function(m) {
      return m.addedNodes.length > 0;
    });
    if (hasNewCards) {
      setTimeout(initSwatchSwap, 100);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
